(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/default-promo-moneyrain-chathost.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/default-promo-moneyrain-chathost.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.default_promo_moneyrain_chathost = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "<i class=\"icon-default icon-200 icon-umbrella\"></i>";
},"1":function(container,depth0,helpers,partials,data) {
    return "<i class=\"icon-default icon-200 icon-chat-host\"></i>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"moneyRain") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":75}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"hasChatHost") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":2,"column":78}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-app-product_start_page-default_promo_moneyrain_chathost'] = svs.app.product_start_page.templates.default_promo_moneyrain_chathost;
})(svs, Handlebars);


 })(window);